


























































































import { Vue, Component } from 'vue-property-decorator'
import { userInfoForm } from '@/constants/applyForm'
import Uploader from '@/utils/uploads'
import FormItem from '@/components/form-item/index.vue'
import MTextarea from '@/components/m-textarea/index.vue'
import Radio from '@/components/Radio.vue'
import { applyUserInfo, getCertifiInfo } from '@/services/apply'
import { CHECK_STATUS } from '@/constants/applyForm'

@Component({
  components: {
    FormItem,
    MTextarea,
    Radio,
  },
})
export default class Info extends Vue {
  formData: ApplyTypes.UserInfoForm = userInfoForm
  avtImage: string = ''
  avtImagePrew: string = ''
  $toast: any
  CHECK_STATUS = CHECK_STATUS
  uploadTag: Set<string> = new Set()

  userVclassTypeOptions = [
    {
      label: '影视',
      value: '1',
      isChecked: false,
    },
    {
      label: '娱乐',
      value: '2',
      isChecked: false,
    },
    {
      label: '原创',
      value: '3',
      isChecked: false,
    },
  ]

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get userInfo() {
    return this.$store.state.userInfo
  }

  // 提交申请
  async apply() {
    console.log('提交申请', this.formData)

    // if (!this.avtImage) {
    //   return this.$toast('请上传头像')
    // }

    if (!this.formData.nickname) {
      return this.$toast('请输入昵称')
    }

    // if (!this.formData.userVclass) {
    //   return this.$toast('请选择擅长领域')
    // }

    // if (!this.formData.introduction) {
    //   return this.$toast('请输入简介')
    // }

    // if (!this.formData.userWork) {
    //   return this.$toast('请输入作品')
    // }

    try {
      let data = {
        ...this.formData,
        uuid: this.userInfoInapp.uuid,
        ticket: this.userInfoInapp.ticket,
        avatar: this.avtImage,
        accountType: 1,
      }
      if (this.uploadTag.size > 0 && data.avatar) {
        let url = new URL(data.avatar)
        data.avatar = url.pathname
      }
      const res = await applyUserInfo(data)
      // const res = { code: 200 }
      if (res && res.code == 200) {
        this.uploadTag.clear()
        // this.publishSuccess = true
        this.$emit('goNext')
      } else {
        this.$toast(res.msg)
      }

      const { uuid, ticket } = this.userInfoInapp
      // this.$store.commit('UpdateUserApplyStatus', CHECK_STATUS.AUDITINT)
      this.$store.dispatch('getColumnistInfoAction', { uuid, ticket })
    } catch (error) {
      console.log(error)
    }
  }

  // check(index: number) {
  //   // 先取消所有选中项
  //   this.userVclassTypeOptions.forEach(item => {
  //     item.isChecked = false
  //   })
  //   //再设置当前点击项选中
  //   this.formData.userVclass = this.userVclassTypeOptions[index].value
  //   // 设置值，以供传递
  //   this.userVclassTypeOptions[index].isChecked = true
  //   //console.log(this.radio);
  // }

  // 上传头像
  onAvtImageChange(e: Event) {
    this.uploadImg(e, 'avtImage')
  }

  // 上传图片
  uploadImg(e: Event, type: string) {
    const target: HTMLInputElement = e.target as HTMLInputElement
    const files: FileList | null = target.files
    if (files && files.length) {
      const fileMaxSize = 1024 * 5 //最大5M
      const size = files[0].size / 1024
      if (size > fileMaxSize) {
        this.$toast('请上传5M以内的图片,请重新选择')
        target.value = ''
        return
      }

      // const { uuid, ticket } = this.userInfoInapp
      const PositiveUploader: any = new Uploader({
        file: files,
      })

      this.avtImagePrew = URL.createObjectURL(files[0])

      PositiveUploader.on('success', (info: any) => {
        ;(this as any)[type] = info.url
        this.uploadTag.add(type)
      })
    }
  }

  beforeMount() {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
  }

  mounted() {
    this.getSettedInfo()
  }

  // getCertifiInfo
  async getSettedInfo() {
    const res = await getCertifiInfo({
      uuid: this.userInfoInapp.uuid,
    })
    if (res.code === 200) {
      if (res.data && res.data.nickname !== '') {
        let resData = res.data
        console.log('resData', resData)
        this.formData.nickname = resData.nickname
        this.formData.introduction = resData.introduction
        this.avtImage = resData.avatar
        this.avtImagePrew = resData.avatar
      }
    }
  }
}
